import type { SyncBlockInstance } from '@atlaskit/editor-synced-block-provider/providers/types';

import { manuallyLogExpExposure } from '@confluence/feature-experiments';

export const syncedBlockLoadSSRData: () => Record<string, SyncBlockInstance> | undefined = () => {
	// Fire a client-side exposure for the SSR preload experiment. The experiment is only
	// evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
	// never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
	// point where the SSR-preloaded sync block data is consumed on the client — ensures every
	// page load records an exposure, allowing us to measure the experiment's effect accurately.
	// Once the optimal value is found, this will be converted to a permanent Statsig config.
	manuallyLogExpExposure('platform_editor_sync_block_ssr_config');
	const rawSyncBlockData: SyncBlockInstance[] =
		typeof globalThis !== 'undefined'
			? (globalThis as any).__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks
			: undefined;

	if (rawSyncBlockData) {
		return rawSyncBlockData.reduce<Record<string, SyncBlockInstance>>((acc, item) => {
			acc[item.resourceId] = item;
			return acc;
		}, {});
	}

	return undefined;
};
